// Google Consent Mode v2 scaffolding + persistence helpers.
// Integrations (GA4, Ads, etc.) can be wired later; the consent signals are
// pushed to the dataLayer now so everything is ready from day one.

const STORAGE_KEY = "centauros_cookie_consent_v1";

export const DEFAULT_PREFS = {
  necessary: true,
  preferences: false,
  analytics: false,
  marketing: false,
};

export function ensureGtag() {
  if (typeof window === "undefined") return;
  window.dataLayer = window.dataLayer || [];
  if (!window.gtag) {
    window.gtag = function gtag() {
      window.dataLayer.push(arguments);
    };
  }
}

// Called on first load, before any consent is given (GDPR/ePrivacy safe defaults).
let defaultsSet = false;
export function setDefaultConsent() {
  if (defaultsSet) return;
  defaultsSet = true;
  ensureGtag();
  window.gtag("consent", "default", {
    ad_storage: "denied",
    ad_user_data: "denied",
    ad_personalization: "denied",
    analytics_storage: "denied",
    functionality_storage: "denied",
    personalization_storage: "denied",
    security_storage: "granted",
    wait_for_update: 500,
  });
}

export function updateConsent(prefs) {
  ensureGtag();
  window.gtag("consent", "update", {
    ad_storage: prefs.marketing ? "granted" : "denied",
    ad_user_data: prefs.marketing ? "granted" : "denied",
    ad_personalization: prefs.marketing ? "granted" : "denied",
    analytics_storage: prefs.analytics ? "granted" : "denied",
    functionality_storage: prefs.preferences ? "granted" : "denied",
    personalization_storage: prefs.preferences ? "granted" : "denied",
    security_storage: "granted",
  });
  window.dataLayer.push({ event: "consent_update", consent: prefs });
}

export function loadConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.prefs) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function saveConsent(prefs) {
  try {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({ prefs, timestamp: new Date().toISOString(), version: 1 })
    );
  } catch {
    /* ignore */
  }
  updateConsent(prefs);
}

export const CONSENT_EVENT = "open-cookie-preferences";

export function openCookiePreferences() {
  window.dispatchEvent(new Event(CONSENT_EVENT));
}
